import React from 'react';
import { Text } from '../Text/Text';
import { BorderConcealer, Header, HugCard } from './Hug.styled';
/**
 * @public
 */
export function Hug({
  bg,
  color = 'text.lightest',
  p,
  fontSize,
  icon,
  iconDisplay,
  colorScheme,
  ...props
}) {
  let iconClone;
  if (React.isValidElement(icon)) {
    iconClone = React.cloneElement(icon, {
      style: {
        display: iconDisplay
      },
      mr: 2,
      mt: '-2px',
      mb: '2px',
      size: 24
    });
  }
  let headerColor = '';
  if (colorScheme && color !== 'text.lightest') {
    headerColor = color;
  } else if (!colorScheme) {
    headerColor = color;
  }
  return React.createElement(HugCard, {
    ...props,
    borderColor: colorScheme ? null : bg || color,
    color: color,
    colorScheme: colorScheme
  }, React.createElement(Header, {
    bg: bg,
    color: headerColor,
    p: p,
    pl: '12px',
    alignItems: 'center',
    colorScheme: colorScheme,
    iconUsesColorScheme: !iconClone?.props?.color
  }, !!iconClone && iconClone, React.createElement(Text, {
    fontSize: fontSize
  }, props.text)), React.createElement(BorderConcealer, null, props.children));
}
Hug.defaultProps = {
  borderRadius: 'xl',
  borderWidth: 1,
  color: 'text.lightest',
  fontSize: 1,
  p: 2
};